import React, { Fragment } from 'react'
import { RightOutlined } from '@ant-design/icons';
import { Link, } from 'react-router-dom'
import './style.css'
export default function CultivateKnowledgeCard(props) {
    const { data } = props;
    return (
        <Link to={data.location}>
            <div className='CultivateKnowledgeCard'>
                <div className='CultivateKnowledgeCard_Title'>
                    <img className='CultivateKnowledgeCard_TitleIcon' src={data.icon} />
                    <div className='CultivateKnowledgeCard_TitleText'>{data.title}</div>
                </div>
                <RightOutlined className='CultivateKnowledgeCard_Icon' />
            </div>
        </Link>
    )
}